const initialStateConfig={
    isLoadingConfig:false,
    valueConfig:'',
    messageConfig:'',
    dataConfig:""
}

const configReducers=(state=initialStateConfig,action)=>{
    switch(action.type){
        case 'FETCH ACTION CONFIG':{
            return{
                ...state,
                isLoadingConfig:true,
            }
        }
        case 'FETCH FAILED CONFIG':{
            return{
                ...state,
                isLoadingConfig:false,
                messageConfig:action.payload
            }
        }
        case 'FETCH SUCCESSED CONFIG':{
            return{
                ...state,
                isLoadingConfig:false,
                valueConfig:action.payload
            }
        }
        case 'SUCCEESED EDIT CONFIG':{
            return{
                ...state,
                isLoadingConfig:false,
                messageConfig:action.message,
                valueConfig:action.payload
            }
        }
        case 'CLEAR STATUS AKSES':{
            return{
                ...state,
                messageConfig:"",
                dataConfig:""
            }
        }
        case 'SUCCEESED CHANGE STATUS AKSES':{
            return{
                ...state,
                isLoadingConfig:false,
                messageConfig:action.message,
                dataConfig:action.payload
            }
        }
        default:
        return state
    }
}
export default configReducers